// extracted by mini-css-extract-plugin
module.exports = {"tip":"Tip_tip__2uVNv","animate":"Tip_animate__1OD6D","bounce":"Tip_bounce__1SQl0"};